import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ThemeContext, Button} from '../../common';
import treasureImg from '../../../images/treasure.png';
import {getResizeImagePaths, onImageError} from '../../../utils';

export default class TreasureChestRedeemModal extends Component {
  static propTypes = {
    goldCoins: PropTypes.number.isRequired,
    isModalOpened: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
    onTreasureChestRedeem: PropTypes.func.isRequired,
    availablePoints: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    asset: PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string,
      type: PropTypes.string,
    }),
  };

  static defaultProps = {
    asset: null,
    description: '',
  };

  onTreasureChestRedeemClose = () => {
    const {onModalClose} = this.props;
    onModalClose();
  };

  render() {
    const {
      id,
      name,
      goldCoins,
      asset,
      description = '',
      isModalOpened,
      onTreasureChestRedeem,
      availablePoints,
    } = this.props;
    const {url = treasureImg, title = name} = asset || {};
    const redeemDisabled = availablePoints < goldCoins;

    return (
      <ThemeContext.Consumer>
        {(theme) => {
          const styles = {
            color: theme.secondaryColor,
          };
          const {defaultImageURL, resizedImageURL} = getResizeImagePaths(url, 100);

          return (
            <Modal
              title="Redeem a treasure"
              isOpen={isModalOpened}
              onClose={this.onTreasureChestRedeemClose}
              contentStyles="modal__treasure-chest"
            >
              <div className="row row_space-between modal__treasure-chest-wrapper">
                <div className="cell cell_auto modal__treasure-chest-img">
                  <figure className="treasure">
                    <div
                      className="treasure__image-wrap row row_vcenter row_center"
                    >
                      <img
                        className="treasure__image"
                        src={resizedImageURL}
                        onError={onImageError(defaultImageURL)}
                        alt={title}
                        title={title}
                      />
                    </div>
                    <figcaption className="treasure__name">{name}</figcaption>
                    <div className="treasure__points" style={styles}>
                      YakGold&nbsp;
                      <b>{goldCoins}</b>
                    </div>
                  </figure>
                </div>
                <div className="cell cell_auto">
                  <div className="delimeter delimeter_vertical"/>
                </div>
                <div className="cell modal__treasure-chest-desc">
                  <div className="row form__label">Description:</div>
                  <div className="row treasure__description">{description}</div>
                </div>
              </div>
              <div className="row row_center">
                <Button
                  size="xl"
                  text="Redeem"
                  handler={() => onTreasureChestRedeem(id)}
                  disabled={redeemDisabled}
                />
              </div>
            </Modal>
          );
        }}
      </ThemeContext.Consumer>
    );
  }
}
